import React, { useEffect } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Settings: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect to designers if on /settings
    if (location.pathname === '/settings') {
      navigate('/settings/designers', { replace: true });
    }
  }, [location.pathname, navigate]);

  const tabs = [
    { name: 'Designers', href: '/settings/designers', current: location.pathname === '/settings/designers' },
    { name: 'Categories', href: '/settings/categories', current: location.pathname === '/settings/categories' },
    ...(user?.role === 'admin' ? [{ name: 'Staff', href: '/settings/staff', current: location.pathname === '/settings/staff' }] : []),
    { name: 'Locations', href: '/settings/locations', current: location.pathname === '/settings/locations' },
  ];

  return (
    <div>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <Link
              key={tab.name}
              to={tab.href}
              className={`
                ${tab.current
                  ? 'border-indigo-500 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              `}
            >
              {tab.name}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;